import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceGroup from "@/pages/ServiceGroup";
import ServiceDetail from "@/pages/ServiceDetail";
import HowWeHelp from "@/pages/HowWeHelp";
import Situation from "@/pages/Situation";
import Team from "@/pages/Team";
import PersonProfile from "@/pages/PersonProfile";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Resources from "@/pages/Resources";
import ResourceCategory from "@/pages/ResourceCategory";
import Article from "@/pages/Article";
import Results from "@/pages/Results";
import NotableCases from "@/pages/NotableCases";
import FeesFunding from "@/pages/FeesFunding";
import Accreditations from "@/pages/Accreditations";
import RegulatoryInfo from "@/pages/RegulatoryInfo";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:group" element={<ServiceGroup />} />
        <Route path="/services/:group/:slug" element={<ServiceDetail />} />
        <Route path="/how-we-help" element={<HowWeHelp />} />
        <Route path="/how-we-help/:slug" element={<Situation />} />
        <Route path="/team" element={<Team />} />
        <Route path="/team/:slug" element={<PersonProfile />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/resources/:category" element={<ResourceCategory />} />
        <Route path="/resources/:category/:slug" element={<Article />} />
        <Route path="/results" element={<Results />} />
        <Route path="/notable-cases" element={<NotableCases />} />
        <Route path="/fees-funding" element={<FeesFunding />} />
        <Route path="/accreditations" element={<Accreditations />} />
        <Route path="/legal-regulatory" element={<RegulatoryInfo />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
